import { ICollection } from "../../automationObjects/Collections/Collection";

export interface IDashboardCollection extends ICollection {

}

export const schema = "AutomationApps.Collections.Dashboards.DashboardCollection"
